import Sentry from '@integrations/Sentry';
import { onSnapshot,Query, QuerySnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';

interface UseCollectionReturn<T> {
  error: Error | boolean;
  loading: boolean;
  collection: QuerySnapshot<T> | undefined
}

function useCollection<T = Object>(query: Query<T>, forceChange: any = 0): UseCollectionReturn<T> {
  const [error, setError] = useState<Error | boolean>(false);
  const [loading, setLoading] = useState(true);
  const [docs, setDocs] = useState<QuerySnapshot<T>>();

  useEffect(
    () => {
      if (query) {
        setLoading(true);
        const unsubscribe = onSnapshot(query, 
          doc => {
            setLoading(false);
            setDocs(doc);
          },
          err => {
            if (err.message.indexOf('insufficient permissions') > -1) {
              console.error('Insufficient permissions to access collection', query);
            }
            Sentry.captureException(err, {
              extra: {
                query,
              }
            }); 
            setError(err);
          }
        );
  
        return () => unsubscribe();
      } else {
        setDocs(undefined);
      }
    }, [forceChange]
  );

  return {
    error,
    loading,
    collection: docs,
  };
}

export default useCollection;
